import React from 'react';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import { useCurrentRefinements } from 'react-instantsearch';

interface AppliedFiltersBlockProps {
  className?: string;
  children?: React.ReactNode;
}

const AppliedFiltersBlock: React.FC<AppliedFiltersBlockProps> = ({
  children,
  className,
}) => {
  const { items } = useCurrentRefinements();
  const refinements =
    items[0] && items[0].refinements ? items[0].refinements : [];

  return (
    <div
      className={className}
      style={refinements.length > 0 ? { display: 'flex' } : { display: 'none' }}
      role="region"
      aria-label="Current applied filters"
    >
      <h2>{Translate('Filtered by', true)} </h2>
      {children}
    </div>
  );
};

const StyledAppliedFiltersBlock = styled(AppliedFiltersBlock)`
  display: flex;
  align-items: center;
  padding: ${vars.spacingXl} 0 0 0;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 3rem;
  @media screen and (min-width: ${vars.breakPointTablet}) {
    padding: ${vars.spacingS} ${vars.spacingL} 0 ${vars.spacingL};
    margin-left: -${vars.spacingL};
    margin-right: -${vars.spacingL};
  }

  h2 {
    display: block;
    margin-top: ${vars.spacingS};
    margin-bottom: ${vars.spacingS};
    ${vars.fontSize4}
    font-weight: ${vars.fontWeightBold};
  }
  .ais-CurrentRefinements,
  .ais-CurrentRefinements-list,
  .ais-CurrentRefinements-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-weight: ${vars.fontWeightRegular};
  }
  .ais-CurrentRefinements,
  .ais-CurrentRefinements-list {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .ais-CurrentRefinements {
    margin-top: ${vars.spacingXs};
    margin-left: 10px;
  }
  .ais-CurrentRefinements-item {
    display: inline-block;
    margin-right: ${vars.spacingXs};
    line-height: 4rem;
  }
  .ais-CurrentRefinements-label,
  .ais-CurrentRefinements-category {
    white-space: nowrap;
    margin-right: ${vars.spacingXs};
    padding: 0 ${vars.spacingS};
    line-height: 1.375;
    font-weight: ${vars.fontWeightRegular};
    ${vars.fontSize4}
  }
  .ais-CurrentRefinements-label {
    padding-left: 0;
    text-transform: capitalize;
  }
  .ais-CurrentRefinements-category {
    background-color: ${vars.greyHavens};
    border-radius: 3px;
    padding-top: ${vars.spacingS};
    padding-bottom: ${vars.spacingS};
  }
  .ais-CurrentRefinements-categoryLabel,
  .ais-CurrentRefinements-delete {
    white-space: nowrap;
    ${vars.fontSize1}
    color: ${vars.coreDarkGrey};
    font-weight: ${vars.fontWeightRegular};
  }
  .ais-CurrentRefinements-delete {
    margin-left: ${vars.spacingS};
    margin-right: ${vars.spacingXs};
    border: 0;
    background-color: whitesmoke;
  }
`;

export default StyledAppliedFiltersBlock;
